var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "container container-medium mt-3 article reading" },
      [
        _c("p", [
          _c("b", [_vm._v("Peaj")]),
          _vm._v(
            " - înregistrarea în format electronic a tarifului de trecere;"
          ),
        ]),
        _c("p", [
          _c("b", [_vm._v("Trecere")]),
          _vm._v(
            " - parcurgerea, o singura data, într-un sens, a unei distante de pe un sector de drum, pod, tunel sau trecatoare de munte, care face parte din reteaua de drumuri nationale din România, pe care se aplica tariful de trecere."
          ),
        ]),
        _c("p", [
          _c("b", [_vm._v("Peaj valabil")]),
          _vm._v(
            " reprezinta înregistrarea, în baza de date a SIEGMCR, a informatiilor privind achitarea corespunzatoare a tarifului de trecere pentru un vehicul, a carui perioada de valabilitate nu a expirat"
          ),
        ]),
        _c("p", [
          _vm._v("Conform "),
          _c("b", [
            _vm._v(
              "NORME METODOLOGICE din 28 aprilie 2015 pentru aplicarea de către Compania Naţională de Autostrăzi şi Drumuri Naţionale din România - S.A. a tarifului de utilizare şi a tarifului de trecere:"
            ),
          ]),
        ]),
        _c("p", [_vm._v("Art. 7")]),
        _c("p", [_vm._v("Tariful de trecere este structurat:")]),
        _c("ul", [
          _c("li", [
            _vm._v(
              "a) pentru vehiculele de transport marfă cu MTMA mai mare sau egală cu 12 tone - în funcţie de numărul de axe şi de numărul de treceri;"
            ),
          ]),
          _c("li", [
            _vm._v(
              "b) pentru vehiculele de transport marfă cu MTMA mai mică de 12 tone - în funcţie de MTMA şi de numărul de treceri;"
            ),
          ]),
          _c("li", [
            _vm._v(
              "c) pentru vehiculele de transport persoane - în funcţie de numărul de locuri şi de numărul de treceri."
            ),
          ]),
        ]),
        _c("p", [
          _vm._v("Conform "),
          _c("b", [
            _vm._v(
              "ORDIN nr. 612 din 28 aprilie 2015 privind stabilirea tarifului de trecere înregistrat prin intermediul sistemului informatic de emitere, gestiune, monitorizare şi control al rovinietei"
            ),
          ]),
        ]),
        _c("p", [
          _vm._v(
            "ANEXĂ: TARIFE DE TRECERE pentru utilizarea podurilor peste Dunăre între Feteşti şi Cernavodă"
          ),
        ]),
        _c("table", { staticClass: "table table-stripped" }, [
          _c("tr", [
            _c("th"),
            _c("th", [_vm._v("Tipul vehiculului")]),
            _c("th", [_vm._v("Numarul de treceri")]),
            _c("th", [_vm._v("Tariful - lei - (cu TVA inclus)")]),
          ]),
          _c("tr", [
            _c("td", { attrs: { rowspan: "3" } }, [_vm._v("1")]),
            _c("td", { attrs: { rowspan: "3" } }, [
              _c("p", [
                _vm._v(
                  "a) Vehicule rutiere de transport persoane cu cel mult 8 + 1 locuri pe scaune, inclusiv conducătorul auto - autoturisme"
                ),
              ]),
              _c("p", [
                _vm._v(
                  "b) Vehicule rutiere cu masa totală maximă autorizată mai mică sau egală cu 3,5 tone, exclusiv vehiculele rutiere de transport persoane"
                ),
              ]),
            ]),
            _c("td", [_vm._v("1")]),
            _c("td", [_vm._v("13,00")]),
          ]),
          _c("tr", [_c("td", [_vm._v("2")]), _c("td", [_vm._v("26,00")])]),
          _c("tr", [_c("td", [_vm._v("20")]), _c("td", [_vm._v("208,00")])]),
          _c("tr", [
            _c("td", { attrs: { rowspan: "3" } }, [_vm._v("2")]),
            _c("td", { attrs: { rowspan: "3" } }, [
              _c("p", [
                _vm._v(
                  "a) Vehicule rutiere de transport persoane cu mai mult de 9 locuri pe scaune, inclusiv conducătorul auto, şi maximum 23 de locuri pe scaune, inclusiv conducătorul auto"
                ),
              ]),
              _c("p", [
                _vm._v(
                  "b) Vehicule rutiere cu masa totală maximă autorizată mai mare de 3,5 tone şi mai mică de 12,0 tone, exclusiv vehiculele rutiere de transport persoane"
                ),
              ]),
            ]),
            _c("td", [_vm._v("1")]),
            _c("td", [_vm._v("47,00")]),
          ]),
          _c("tr", [_c("td", [_vm._v("2")]), _c("td", [_vm._v("94,00")])]),
          _c("tr", [_c("td", [_vm._v("20")]), _c("td", [_vm._v("818,00")])]),
          _c("tr", [
            _c("td", { attrs: { rowspan: "3" } }, [_vm._v("3")]),
            _c("td", { attrs: { rowspan: "3" } }, [
              _c("p", [
                _vm._v(
                  "a) Vehicule rutiere de transport persoane cu mai mult de 23 de locuri pe scaune (inclusiv conducătorul auto)"
                ),
              ]),
              _c("p", [
                _vm._v(
                  "b) Vehicule rutiere cu masa totală maximă autorizată mai mare sau egală cu 12,0 tone şi cu maximum 3 axe (inclusiv), exclusiv vehiculele rutiere de transport persoane"
                ),
              ]),
            ]),
            _c("td", [_vm._v("1")]),
            _c("td", [_vm._v("64,00")]),
          ]),
          _c("tr", [_c("td", [_vm._v("2")]), _c("td", [_vm._v("128,00")])]),
          _c("tr", [_c("td", [_vm._v("20")]), _c("td", [_vm._v("1.114,00")])]),
          _c("tr", [
            _c("td", { attrs: { rowspan: "3" } }, [_vm._v("4")]),
            _c("td", { attrs: { rowspan: "3" } }, [
              _c("p", [
                _vm._v(
                  "Vehicule rutiere cu masa totală maximă autorizată mai mare sau egală cu 12,0 tone şi cu minimum 4 axe (inclusiv), exclusiv vehiculele rutiere de transport persoane"
                ),
              ]),
            ]),
            _c("td", [_vm._v("1")]),
            _c("td", [_vm._v("91,00")]),
          ]),
          _c("tr", [_c("td", [_vm._v("2")]), _c("td", [_vm._v("182,00")])]),
          _c("tr", [_c("td", [_vm._v("20")]), _c("td", [_vm._v("1.584,00")])]),
        ]),
        _c("p", [
          _vm._v("Confom "),
          _c("b", [
            _vm._v(
              "ORDONANŢĂ DE URGENŢĂ nr. 8 din 22 aprilie 2015 pentru modificarea şi completarea unor acte normative"
            ),
          ]),
        ]),
        _c("p", [
          _vm._v(
            "Fapta de a circula fara peaj valabil constituie contraventie si se sanctioneaza cu amenda."
          ),
        ]),
        _c("p", [
          _vm._v(
            " ANEXA nr. 2: Cuantumul amenzii contravenţionale aplicabile utilizatorilor în cazul lipsei peajului valabil"
          ),
          _c("br"),
          _vm._v(" (- Anexa nr. 4 la Ordonanţa Guvernului nr. 15/2002) "),
        ]),
        _c("table", { staticClass: "table table-stripped" }, [
          _c("tr", [
            _c("th", { attrs: { rowspan: "2" } }),
            _c("th", { attrs: { rowspan: "2" } }, [
              _vm._v("Tipul vehiculului"),
            ]),
            _c("th", { attrs: { colspan: "2" } }, [
              _vm._v("Cuantumul amenzii contravenţionale (lei)"),
            ]),
          ]),
          _c("tr", [_c("th", [_vm._v("minim")]), _c("th", [_vm._v("maxim")])]),
          _c("tr", [
            _c("td", [_vm._v("1")]),
            _c("td", [
              _c("p", [
                _vm._v(
                  "a) Vehicule rutiere de transport persoane cu cel mult 8 + 1 locuri pe scaune, inclusiv conducătorul auto - autoturisme"
                ),
              ]),
              _c("p", [
                _vm._v(
                  "b) Vehicule rutiere cu masa totală maximă autorizată mai mică sau egală cu 3,5 tone, exclusiv vehiculele rutiere de transport persoane"
                ),
              ]),
            ]),
            _c("td", [_vm._v("130")]),
            _c("td", [_vm._v("260")]),
          ]),
          _c("tr", [
            _c("td", [_vm._v("2")]),
            _c("td", [
              _c("p", [
                _vm._v(
                  "a) Vehicule rutiere de transport persoane cu mai mult de 9 locuri pe scaune, inclusiv conducătorul auto, şi maximum 23 de locuri pe scaune, inclusiv conducătorul auto"
                ),
              ]),
              _c("p", [
                _vm._v(
                  "b) Vehicule rutiere cu masa totală maximă autorizată mai mare de 3,5 tone şi mai mică de 12,0 tone, exclusiv vehiculele rutiere de transport persoane"
                ),
              ]),
            ]),
            _c("td", [_vm._v("470")]),
            _c("td", [_vm._v("940")]),
          ]),
          _c("tr", [
            _c("td", [_vm._v("3")]),
            _c("td", [
              _c("p", [
                _vm._v(
                  "a) Vehicule rutiere de transport persoane cu mai mult de 23 de locuri pe scaune (inclusiv conducătorul auto)"
                ),
              ]),
              _c("p", [
                _vm._v(
                  "b) Vehicule rutiere cu masa totală maximă autorizată mai mare sau egală cu 12,0 tone şi cu maximum 3 axe (inclusiv), exclusiv vehiculele rutiere de transport persoane"
                ),
              ]),
            ]),
            _c("td", [_vm._v("640")]),
            _c("td", [_vm._v("1.280")]),
          ]),
          _c("tr", [
            _c("td", [_vm._v("4")]),
            _c("td", [
              _c("p", [
                _vm._v(
                  "Vehicule rutiere cu masa totală maximă autorizată mai mare sau egală cu 12,0 tone şi cu minimum 4 axe (inclusiv), exclusiv vehiculele rutiere de transport persoane"
                ),
              ]),
            ]),
            _c("td", [_vm._v("910")]),
            _c("td", [_vm._v("1.820")]),
          ]),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }